"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Avatar_1 = require("@mui/material/Avatar");
var Celebration_1 = require("@mui/icons-material/Celebration");
var Typography_1 = require("@mui/material/Typography");
var IconButton_1 = require("@mui/material/IconButton");
var Delete_1 = require("@mui/icons-material/Delete");
var Edit_1 = require("@mui/icons-material/Edit");
var react_1 = require("react");
var GenericModal_1 = require("./GenericModal");
var material_1 = require("@mui/material");
var Download_1 = require("@mui/icons-material/Download");
var Event_1 = require("../models/Event");
var Role_1 = require("../shared/utilities/Role");
function Event(props) {
    var role = Role_1.default();
    var deleteModalRef = react_1.useRef(null);
    return (React.createElement(material_1.ListItem, { sx: { paddingRight: '90px', paddingLeft: '0px' }, secondaryAction: React.createElement(React.Fragment, null,
            props.documentLocation != null &&
                React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", onClick: function () {
                        var fileType = props.documentLocation.split('.').pop();
                        fetch(props.documentLocation, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/' + fileType,
                            },
                        })
                            .then(function (response) { return response.blob(); })
                            .then(function (blob) {
                            var _a;
                            // Create blob link to download
                            var fileType = props.documentLocation.split('.').pop();
                            var url = window.URL.createObjectURL(new Blob([blob]));
                            var link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', props.name + "." + fileType);
                            // Append to html link element page
                            document.body.appendChild(link);
                            // Start download
                            link.click();
                            // Clean up and remove the link
                            (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
                        });
                    } },
                    React.createElement(Download_1.default, null)),
            role === 'Admin' &&
                React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", onClick: function () {
                        var event = new Event_1.EventModel();
                        event.EventId = props.id;
                        event.EventName = props.name;
                        event.EventDescription = props.description;
                        event.EventLocation = props.location;
                        event.EventFileLocation = props.documentLocation;
                        event.EventStartTime = props.startDate;
                        event.EventEndTime = props.endDate;
                        event.EventCoordinators = props.eventCoordinators;
                        props.openEvent(event);
                    } },
                    React.createElement(Edit_1.default, null)),
            role === 'Admin' &&
                React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", onClick: function () {
                        var _a;
                        deleteModalRef && ((_a = deleteModalRef === null || deleteModalRef === void 0 ? void 0 : deleteModalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen());
                    } },
                    React.createElement(Delete_1.default, null))) },
        React.createElement(material_1.ListItemAvatar, null,
            React.createElement(Avatar_1.default, null,
                React.createElement(Celebration_1.default, null))),
        React.createElement(material_1.ListItemText, { primary: props.name, secondary: React.createElement(React.Fragment, null,
                React.createElement(Typography_1.default, { display: "block", component: "span", variant: "body2", color: "text.primary" }, props.description),
                React.createElement(Typography_1.default, { display: "block", component: "span", variant: "body2", color: "text.primary" },
                    React.createElement("b", null, "Location:"),
                    " ",
                    props.location),
                React.createElement(Typography_1.default, { display: "block", component: "span", variant: "body2", color: "text.primary" }, props.eventCoordinators != null && props.eventCoordinators.length > 0 &&
                    React.createElement(React.Fragment, null,
                        React.createElement("b", null, "Event Coordinator(s):"),
                        " ",
                        props.eventCoordinators)),
                React.createElement(Typography_1.default, { display: "block", component: "span", variant: "body2", color: "text.primary" },
                    React.createElement("b", null, "Time:"),
                    " ",
                    (props.startDate.toLocaleString('en-US', {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    }) + " " + props.startDate.toLocaleTimeString('en-US', { timeStyle: 'short', hour12: true }) + "-" + props.endDate.toLocaleTimeString('en-US', { timeStyle: 'short', hour12: true })).replace('a.m.', 'AM').replace('p.m.', 'PM'))) }),
        React.createElement(GenericModal_1.default, { ref: deleteModalRef, text: 'Are you sure you want to delete event ' + props.name + '?', action: props.delete, value: props.id })));
}
exports.default = Event;
//# sourceMappingURL=Event.js.map